// ./src/lib/ToastWrapper.js

import toast from './toast';

const options = {
  className: 'toast__message',
};

export default {
  show(msg) {
    toast.Toast(msg, options);
  },
};
